/* tslint:disable */
/* eslint-disable */
export enum TransferStatusEnum {
  None = 0,
  ApprovalPending = 1,
  Transferred = 2,
}
